import OPPAnalytics from "./analytics/analytics";

import { createRoot } from 'react-dom/client';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';

import { register, unregister } from './registerServiceWorker';

import { createBrowserHistory } from 'history';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router';
import { Router } from 'react-router-dom';

import config from '@config';
import createStore, { StoreContext } from '@stores';

import App from '@src/App';

import Analytics from 'analytics';
// Include perfume.js analytics plugin
import perfumePlugin from '@analytics/perfumejs';

// Imports => SCSS
import { default as test } from '@config/i18next';
import '@styles/index.scss';
import Perfume from "perfume.js";
import { Provider } from "react-redux";
import { AnalyticsProvider } from "use-analytics";
import { RTKStore } from "./rtk/store";
import { QueryParamProvider } from "use-query-params";
import { PermissionChecker } from "./views/ac-permissions-checkes";

console.log(test);

const browserHistory = createBrowserHistory();
const routing = new RouterStore();
const store = createStore(config);

const history = syncHistoryWithStore(browserHistory, routing);

/* Initialize analytics & load plugins */
const analytics = Analytics({
  app: 'merchant-portal',
  debug: true,
  plugins: [
    OPPAnalytics({url: `${config.apiUrl}/analytics`}),
    // Include perfume.js plugin with no options set.
    // This will send data to all analytics providers by default
    perfumePlugin({
      perfume: Perfume
    }),
  ]
})

document.body.innerHTML = '<div id="app"></div>';
const root = createRoot(document.getElementById('app'));
root.render(
  <AnalyticsProvider instance={analytics}>
    <Provider store={RTKStore}>
      <StoreContext.Provider value={store}>
        <Router history={history}>
          <QueryParamProvider adapter={ReactRouter5Adapter}>
            <PermissionChecker>
              <App />
            </PermissionChecker>
          </QueryParamProvider>
        </Router>
      </StoreContext.Provider>
    </Provider>
  </AnalyticsProvider>
);

if (process.env.NODE_ENV === 'production') {
  register();
} else {
  unregister();
}

if (window && window.addEventListener) {
  const $buoop = {
    required: { e: -2, f: -2, o: -2, s: -1, c: -2 },
    unsupported: true,
    insecure: true,
    noclose: true,
    no_permanent_hide: true,
    reminder: 0,
    nostatistics: true,
    api: 2022.01,
    text: {
      msg: '<h2 class="buorg-title">%APP_NAME%</h2>',
      msgmore:
        '<p class="buorg-message">We see that you are trying to access the <strong>%APP_NAME%</strong> application via <strong>{brow_name}</strong>.</p><p class="buorg-message">Unfortunately this browser is outdated and cannot handle the application appropriately.</p><p class="buorg-message">Please <a{up_but}>update</a> your webbrowser or try again with any modern webbrowser, for example Chrome, Safari, Firefox or Microsoft Edge.</p>',
    },
  };

  const $buo_f = () => {
    const elem = document.createElement('script');
    elem.src = '//browser-update.org/update.min.js';
    document.body.appendChild(elem);
  };

  try {
    document.addEventListener('DOMContentLoaded', $buo_f, false);
  } catch (event) {
    window.attachEvent('onload', $buo_f);
  }

  // (A)sync loading of typekit fontface
  var fontKey = 'tkf_loaded';
  var stylesheet = 'https://use.typekit.net/xfj2dek.css';

  // If we've loaded it once before, load the CSS in a blocking way (media="print").
  // Otherwise, we load it asynchronously.
  var hasFontKey = sessionStorage.getItem(fontKey);
  var tag = document.createElement('link');
  tag.rel = 'stylesheet';
  tag.href = stylesheet;

  if (!hasFontKey) {
    tag.media = 'print';
  }
  // Once the font has loaded:
  // - Set the media type, thereby applying the CSS.
  // - Store a boolean indicating we've already loaded the font.
  const $onTypekitLoad = (script) => {
    script.media = 'all';
    sessionStorage.setItem(fontKey, 'true');
  };

  const $loadTypekit = () => {
    document.body.appendChild(tag);
    if (!hasFontKey) {
      tag.addEventListener('load', (event) => $onTypekitLoad(tag));
    }
  };

  try {
    document.addEventListener('DOMContentLoaded', $loadTypekit, false);
  } catch (event) {
    window.attachEvent('load', $loadTypekit);
  }
}

// this for HMR in local dev mod ONLY
if (module.hot) {
  module.hot.accept(function (err) {
    console.log('An error occurred while accepting new version');
  });
}
